import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { useDispatch } from 'react-redux';

import { openModalBottom } from '../../../../actions/ui';
import PeriodSelectDate from './PeriodSelectDate';
import PeriodSelectTime from './PeriodSelectTime';
import { getDefaultProfessionalHours } from '../horariosExtra/HorarioExtra';

const timezone = process.env.REACT_APP_TIMEZONE;

export const PeriodSelect = ({ editMode, descanso, saveChanges, objProfesional }) => {

    const dispatch = useDispatch();
    
    const isHorarioExtra = descanso.tipo === 'horario_extra';

    const [minutesGap, ] = useState(5);

    const [fechaCalendarSimple, setFechaCalendarSimple] = useState( new Date() );
    const [fechaCalendarCompuesta, setFechaCalendarCompuesta] = useState( [new Date(), new Date()] );
    const [allDaySelected, setAllDaySelected] = useState(false);

    const [initDate, setInitDate] = useState( new Date() );
    const [endDate, setEndDate] = useState(new Date() );

    useEffect(() => {
        if (!descanso || !descanso._id) return;
        
        let newInitDate, newEndDate;
        
        if (isHorarioExtra) {
            if (descanso.horaInicio && descanso.horaFin) {
                newInitDate = moment.tz( descanso.horaInicio , timezone).toDate(); 
                newEndDate = moment.tz( descanso.horaFin , timezone).toDate();
            } else {
                const fechaBase = moment.tz(descanso.fechaInicio || new Date(), timezone);
                const { horaInicioDefault, horaFinDefault } = getDefaultProfessionalHours(objProfesional, fechaBase);
                
                const fechaInicio = fechaBase.clone()
                    .hours(horaInicioDefault.hours())
                    .minutes(horaInicioDefault.minutes())
                    .seconds(0)
                    .milliseconds(0);
                const fechaFin = fechaBase.clone()
                    .hours(horaFinDefault.hours())
                    .minutes(horaFinDefault.minutes())
                    .seconds(0)
                    .milliseconds(0);
                
                newInitDate = fechaInicio.toDate();
                newEndDate = fechaFin.toDate();
            }
        } else {
            newInitDate = moment.tz( descanso.fechaInicio , timezone).toDate(); 
            newEndDate = moment.tz( descanso.fechaFin , timezone).toDate();
        }
        
        if (initDate && moment.tz(initDate, timezone).isValid()) {
            const fechaActualInicio = moment.tz(initDate, timezone).startOf('day');
            const nuevaFechaInicio = moment.tz(newInitDate, timezone).startOf('day');
            
            if (!fechaActualInicio.isSame(nuevaFechaInicio, 'day')) {
                setFechaCalendarSimple( newInitDate );
            }
        } else {
            setFechaCalendarSimple( newInitDate );
        }
        
        setInitDate( newInitDate );
        setEndDate( newEndDate );
        setFechaCalendarCompuesta( [newInitDate, newEndDate] );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descanso.fechaInicio, descanso.fechaFin, descanso.horaInicio, descanso.horaFin, isHorarioExtra, descanso._id]);

    useEffect(() => {        
        if (!isHorarioExtra) {
            const inicioCompleto = moment( initDate ).format('H:mm:ss') === '0:00:00';
            const finCompleto = moment( endDate ).format('H:mm:ss') === '23:59:00';
            if( inicioCompleto && finCompleto ){
                setAllDaySelected( true );
            } else {
                setAllDaySelected( false );
            }
        } else {
            setAllDaySelected( false );
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initDate, endDate, isHorarioExtra]); 

    const dateChange = (e) => {
        if( !editMode ){
            dispatch( openModalBottom({text: ['Debes activar la edición para poder realizar cambios'], timeOut: 3}) );
            return;
        }

        const horasInicio = initDate.getHours();
        const minutosInicio = initDate.getMinutes();
        const horasFin = endDate.getHours();
        const minutosFin = endDate.getMinutes();

        if( descanso.tipo === 'ausencia' ){
            const nuevaFecha = new Date(e);
            
            const horaInicio = moment.tz(nuevaFecha, timezone)
                .hours(horasInicio)
                .minutes(minutosInicio)
                .seconds(0)
                .milliseconds(0)
                .toDate();
            const horaFin = moment.tz(nuevaFecha, timezone)
                .hours(horasFin)
                .minutes(minutosFin)
                .seconds(0)
                .milliseconds(0)
                .toDate();
            
            setFechaCalendarSimple( nuevaFecha );
            setInitDate( horaInicio );
            setEndDate( horaFin );
            
            saveChanges( horaInicio, horaFin );
        } else {
            const fechaInicio = new Date(e[0]);
            const fechaFin = e[1] ? new Date(e[1]) : fechaInicio;
            
            if (fechaFin < fechaInicio) {
                setFechaCalendarCompuesta([fechaInicio, fechaInicio]);
                return;
            }
            
            setFechaCalendarCompuesta([fechaInicio, fechaFin]);
            
            if (isHorarioExtra) {
                const horaInicio = moment.tz(fechaInicio, timezone)
                    .hours(horasInicio)
                    .minutes(minutosInicio)
                    .seconds(0)
                    .milliseconds(0)
                    .toDate();
                const horaFin = moment.tz(fechaFin, timezone)
                    .hours(horasFin)
                    .minutes(minutosFin)
                    .seconds(0)
                    .milliseconds(0)
                    .toDate();
                
                setInitDate( horaInicio );
                setEndDate( horaFin );
                
                saveChanges( horaInicio, horaFin );
            } else {
                const horaInicioMoment = moment.tz(fechaInicio, timezone);
                const horaFinMoment = moment.tz(fechaFin, timezone);
                
                const horaInicio = allDaySelected 
                    ? horaInicioMoment.hours(0).minutes(0).seconds(0).milliseconds(0).toDate()
                    : horaInicioMoment
                        .hours(horasInicio)
                        .minutes(minutosInicio)
                        .seconds(0)
                        .milliseconds(0)
                        .toDate();
                
                const horaFin = allDaySelected
                    ? horaFinMoment.hours(23).minutes(59).seconds(0).milliseconds(0).toDate()
                    : horaFinMoment
                        .hours(horasFin)
                        .minutes(minutosFin)
                        .seconds(0)
                        .milliseconds(0)
                        .toDate();
                
                setInitDate( horaInicio );
                setEndDate( horaFin );
                
                saveChanges( horaInicio, horaFin );
            }
        }
    };

    const toggleDaySelected = (e) => {
        e.stopPropagation();
        let horaInicio = moment( initDate ).hours(0).minutes(0).seconds(0).toDate();
        let horaFin = moment( endDate ).hours(23).minutes(59).seconds(0).toDate();
        if( editMode ){
            if( allDaySelected ){
                horaInicio = moment( initDate ).hours(8).minutes(0).seconds(0).toDate();
                horaFin = moment( endDate ).hours(20).minutes(0).seconds(0).toDate();
            }

            setInitDate( horaInicio );
            setEndDate( horaFin );
                
            saveChanges( horaInicio, horaFin );
        } else {
            dispatch( openModalBottom({text: ['Debes activar la edición para poder realizar cambios'], timeOut: 3}) );
        }
    };

    const changeHours = ( operation, from = true ) => {
        let newHour;
        if( operation === 'add' ){
            newHour = moment( from ? initDate : endDate ).add(1, 'hours' ).toDate();
        } else {
            newHour = moment( from ? initDate : endDate ).subtract(1, 'hours' ).toDate();
        }
        
        if( from ){
            setInitDate( newHour );
            saveChanges( newHour, endDate );
        } else {
            setEndDate( newHour );
            saveChanges( initDate, newHour );
        }
    }
    
    const changeMinutes = ( operation, from = true ) => {
        let newHour;
        const minutesToAdd = isHorarioExtra ? 1 : minutesGap;
        if( operation === 'add' ){
            newHour = moment( from ? initDate : endDate ).add(minutesToAdd, 'minutes' ).toDate();
        } else {
            newHour = moment( from ? initDate : endDate ).subtract(minutesToAdd, 'minutes' ).toDate();
        }
        
        if( from ){
            setInitDate( newHour );
            saveChanges( newHour, endDate );
        } else {
            setEndDate( newHour );
            saveChanges( initDate, newHour );
        }
    }
    
  return (
    <div 
        className={ `vacacional-period`}
    >
        <div 
            className='ylm-select vacacional-period-select'
        >
            <div
                className='selectors'
            >                
                <PeriodSelectDate 
                    initDate={initDate}
                    setInitDate={setInitDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    dateChange={ dateChange }
                    descanso={ descanso }
                    fechaCalendarSimple = { fechaCalendarSimple }
                    fechaCalendarCompuesta= { fechaCalendarCompuesta }
                    isHorarioExtra={ isHorarioExtra }
                />
                <PeriodSelectTime
                    initDate={ initDate }
                    endDate={ endDate }
                    changeHours={ changeHours }
                    changeMinutes={ changeMinutes }
                    allDaySelected={ allDaySelected }
                    toggleDaySelected={ toggleDaySelected }
                    isHorarioExtra={ isHorarioExtra }
                />
                
            </div>
        </div>
    </div>
  )
}
